import Vue from 'vue';
import Vuex from 'vuex';
import { productGetters, contentGetters, authorisationGetters } from './getters';
import { productMutations, contentMutations, authorisationMutations } from './mutations';
import { productActions, contentActions, authorisationActions } from './actions';

Vue.use(Vuex);

const store = new Vuex.Store({
  strict: true,
  state: {
    basket: [],
    showLoader: false,
    isError: false,
    product: [],
    products: [],
    productCategories: [],
    productGroups: [],
    topNavigation: [],
    sideNavigation: [],
    pageContent: [],
    currentPage: [],
    token: localStorage.getItem('token') || '',
  },
  getters: Object.assign({}, productGetters, contentGetters, authorisationGetters),
  mutations: Object.assign({}, productMutations, contentMutations, authorisationMutations),
  actions: Object.assign({}, productActions, contentActions, authorisationActions),
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js